import { TextContainer } from 'components/container'
import { Video } from 'components/video'

export const Intro = () => (
  <TextContainer>
    <p>
      Коми – небольшой народ, живущий на севере России. Антимусорные протесты в
      Шиесе несколько лет назад спровоцировали в республике гражданскую
      активность и мощнейший подъем национального самосознания. Среди наших
      героев – языковой активист Алексей Иванов, уехавший из России из-за
      уголовного дела; Павел Андреев – бывший директор издания "7x7", которое
      Роскомнадзор оштрафовал за публикации на государственном коми языке.
      Другой герой – учитель истории Никита Тушканов – был вынужден выучить
      русский, чтобы учиться в вузе, впоследствии стал гражданским активистом, а
      после – был осужден на 5 лет. Как коми будут бороться за свою идентичность
      и что будет с этим народом дальше – смотрите в нашем выпуске.
    </p>

    <Video id="_s4KtbTmzSc" poster="https://gdb.currenttime.tv/01000000-0a00-0242-c8fb-08dc1b80ffad_1920.jpg" />
  </TextContainer>
)
